export enum WellKnownActivitiesEnum {
  businessLogicIntervention = '8ad27e43-749a-4976-95ac-4198ee29b60e',
  callCreated = '6c8f3864-11da-4c24-8601-0e90aedb0e33',
  createFromCsv = '13d25464-889e-442d-aea1-6cc0d9e7d2d3',
  valueChanged = '945e284b-12cd-4774-93e5-7c3352094555',
  updateFromCSV = '0230cd50-c721-41f3-b2c3-2dd053c9d76f',
  uploadFromConnector = '4ae91014-27fd-4764-8477-2c1cfbaa266a',
  reuploadFromConnector = 'ed348554-eb34-43a4-a5f3-776d09733004',
  createDiagnosticClaim = 'ca4b7514-693f-433c-aded-143450f45df0',
  archived = '9e1dfc66-67d2-49ae-9f8b-6bbce87175a9',
  unarchived = '310a8a3e-f99d-43e1-9ae5-6d6e4bf53184',
  ownership = '3dca2d43-aaf1-4e36-8636-22c706d66146',
  EOBFileReceived = '826dbc91-aca8-426b-82f9-89d9e799a8c3',
}

export enum WellKnownActorsEnum {
  businessLogic = '5a6371b7-c3ac-468a-a43f-eb2de0e95eda',
  ivrInfoExtractor = '3f76cf66-3a3b-423d-9494-5200030b843b',
  rcmAgent = '23e90309-70d8-4415-9924-5b69fdd1c029',
  connectorIntegration = '450910c3-f776-4234-8e35-107c725dec62',
}

export enum wellKnownEntityIDs {
  insurerPhoneNumber = 34,
  ownerName = 32,
  ownerId = 66,
}
